// extracted by mini-css-extract-plugin
module.exports = {"keyMomentsContainer":"styles-module__keyMomentsContainer___1f4KL"};